import { Switch as AntdSwitch } from 'antd-mobile'
import { connect, mapProps } from '@formily/react'
import { isNum } from '@formily/shared'

export const Switch = connect(
  AntdSwitch,
  mapProps(
    {
      value: 'checked',
    },
    (props) => {
      const onChange = props.onChange
      delete props['value']
    //   props.checked = isNum(props.checked) ? props.checked === 1 : props.checked
      props.checked = Boolean(props.checked)
      return {
        ...props,
        onChange(checked) {
          onChange?.(checked)
        },
        style: {
            position: 'relative',
            top: '-2px',
            ...props.style
        }
      }
    }
  )
)

export default Switch